import { useQuery } from '@apollo/client/react';

import {
  GetCompanyFeatureFlagsDocument,
  GetCompanyFeatureFlagsQuery,
  GetFeatureFlagsDocument,
  GetFeatureFlagsQuery,
} from '~/graphql/generated/graphql';
import { getMe } from '~/graphql/utility';

// スペルミスしないようにfeature定義
// リリースされてフラグ削除するときはここも忘れず削除すること
type FeatureFlag =
  | 'AuditEventCsv'
  | 'Issue9813-before-promotion'
  | 'Issue9813-promotion'
  | 'Issue9813-after-promotion'
  | 'Issue9790-incentive-materials'
  | '11616-delete_old_view'
  | 'Issue12674-pharmacy_two_domain'
  | 'Issue12646-yakumaru-feature'
  | 'Issue11803-disable_announce_organization_business_hour_modal'
  | 'Issue12559-payment_examination-feature'
  | 'Issue13690-new_agent'
  | 'Issue13782-password_policy'
  | 'Issue14251-print_outpatient_questionnaire'
  | 'medicine_note_auto_link-project';

const getFeatureFlags = (data?: GetFeatureFlagsQuery) => {
  if (!data) return [];

  return getMe(data)?.featureNames || [];
};

const getCompanyFeatureFlags = (data?: GetCompanyFeatureFlagsQuery) => {
  if (!data) return [];

  return getMe(data)?.organization.company.featureNames || [];
};

export const useFeatureFlag = (feature: FeatureFlag) => {
  const { data } = useQuery(GetFeatureFlagsDocument, {
    fetchPolicy: 'cache-and-network',
  });
  const featureFlags = getFeatureFlags(data);

  return featureFlags.includes(feature);
};

export const useCompanyFeatureFlag = (feature: FeatureFlag) => {
  const { data, loading } = useQuery(GetCompanyFeatureFlagsDocument, {
    fetchPolicy: 'cache-and-network',
  });
  const featureFlags = getCompanyFeatureFlags(data);

  return { isEnabled: featureFlags.includes(feature), loading };
};
